import {getNames} from './state';
import _ from "lodash";
export const getAllNames = () => {
    return getNames().then(
        (res) => {
            const data = _.get(res, 'data', {});
            return _.get(data, 'state.desired.SettingsNames', _.get(data, 'state.reported.SettingsNames', {}));
        }
    )
}

export const getRelaysNames = () => {
    return getAllNames().then(
        (res) => _.get(res, 'relays', {})
    )
}

export const getTemperatureNames = () => {
    return getAllNames().then(
        (res) => _.get(res, 'temperature', {})
    )
}